/**
 * Taken from https://github.com/elimuinformatics/vcf2fhir/blob/master/vcf2fhir/gene_ref_seq.py with modification for TS.
 */
const b37 = {
  chr1: 'NC_000001.10',
  chr2: 'NC_000002.11',
  chr3: 'NC_000003.11',
  chr4: 'NC_000004.11',
  chr5: 'NC_000005.9',
  chr6: 'NC_000006.11',
  chr7: 'NC_000007.13',
  chr8: 'NC_000008.10',
  chr9: 'NC_000009.11',
  chr10: 'NC_000010.10',
  chr11: 'NC_000011.9',
  chr12: 'NC_000012.11',
  chr13: 'NC_000013.10',
  chr14: 'NC_000014.8',
  chr15: 'NC_000015.9',
  chr16: 'NC_000016.9',
  chr17: 'NC_000017.10',
  chr18: 'NC_000018.9',
  chr19: 'NC_000019.9',
  chr20: 'NC_000020.10',
  chr21: 'NC_000021.8',
  chr22: 'NC_000022.10',
  chrX: 'NC_000023.10',
  chrY: 'NC_000024.9',
  chrM: 'NC_012920.1',
};

const b38 = {
  chr1: 'NC_000001.11',
  chr2: 'NC_000002.12',
  chr3: 'NC_000003.12',
  chr4: 'NC_000004.12',
  chr5: 'NC_000005.10',
  chr6: 'NC_000006.12',
  chr7: 'NC_000007.14',
  chr8: 'NC_000008.11',
  chr9: 'NC_000009.12',
  chr10: 'NC_000010.11',
  chr11: 'NC_000011.10',
  chr12: 'NC_000012.12',
  chr13: 'NC_000013.11',
  chr14: 'NC_000014.9',
  chr15: 'NC_000015.10',
  chr16: 'NC_000016.10',
  chr17: 'NC_000017.11',
  chr18: 'NC_000018.10',
  chr19: 'NC_000019.10',
  chr20: 'NC_000020.11',
  chr21: 'NC_000021.9',
  chr22: 'NC_000022.11',
  chrX: 'NC_000023.11',
  chrY: 'NC_000024.10',
  chrM: 'NC_012920.1',
};

export const getGenomicsReferenceSequence = (
  buildReference: 'GRCh37' | 'GRCh38',
  chromosome: string,
) => {
  if (buildReference === 'GRCh37') {
    // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
    return b37[chromosome];
  }

  if (buildReference === 'GRCh38') {
    // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
    return b38[chromosome];
  }
};
